import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  clpIntercomMessage: 'I am interested in Local Currency Collection',
  clpHeader: 'Allow your customers to pay in their local currency.',
  clpDescription:
    'Simplify your billing processes by allowing your customers to pay in their local currencies without incurring international transfer FEES. You can collect payments in MXN, COP, or USD locally.',
  clpActionBtn: 'Request this solution',
  clpBenefit1:
    'Payment Button (Embedded System). Implement our payment button with just a few lines of code.',
  clpBenefit2: 'API and Infrastructure for FX Processing and Transfers.',
  clpBenefit3: 'Create a new revenue stream.',
  clpBenefit4:
    'Save your clients hundreds of dollars in fees and exchange rates.',
  clpDisclaimer:
    '**This product is made possible by EFEX Inc’s alliance with regulated financial entities in the US, Mexico and Canada.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const COLLECT_LOCAL_PAY_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    clpIntercomMessage: 'Estoy interesado en Cobranza en Moneda Local',
    clpHeader: 'Permite a tus clientes pagar en su moneda local',
    clpDescription:
      'Simplifica tus procesos de cobro al permitir que tus clientes paguen en sus monedas locales sin incurrir en transferencias internacionales. Puedes cobrar en MXN, COP o USD de forma local.',
    clpActionBtn: 'Solicita esta solución',
    clpBenefit1:
      'Botón de Pago (Embedded System). Implementa nuestro botón de pago con solo unas líneas de código.',
    clpBenefit2:
      'API e Infraestructura para Procesamiento de FX y Transferencias.',
    clpBenefit3: 'Genera una nueva fuente de revenue.',
    clpBenefit4:
      'Ahórrale cientos de dólares en comisiones y tasas de cambio a tus clientes.',
    clpDisclaimer:
      '**Este producto es posible gracias a las alianzas de EFEX Inc con entidades financieras reguladas en EEUU, México y Colombia',
  },
};

export default COLLECT_LOCAL_PAY_LABELS;
